export default {"src":"/_next/static/media/back-to-TOP.828a8d4e.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};